import { validate_component } from "svelte/internal";
import { get } from 'svelte/store';
import { firebase } from "../firebase";
import db from "../firebase";
import { collection, doc, setDoc, getDoc } from "firebase/firestore";
import { modalS, panelController } from "../stores/service";

function updateDataService(item) {
  panelController.update((service) => {
    service.service = item;
    /* console.log('updateDataService', service.service); */
    
    return service;
  });
}

function GetserviceData() {
  let data = get(panelController);
  
  return {
    collection: 'service',
    id: data.firebase.docs[0].id,
    data: data.service
  }
}

export async function readReadTime(data) {
  let doc = { data: [], status: true, error: false, err: '' };

  const docs = await db.collection(data.collection).doc(data.id);
  const observer = docs.onSnapshot(
    (docSnapshot) => {

      updateDataService(docSnapshot.data());

      doc.data = data.data;
    },
    (err) => {
      doc.err = err;
      doc.status = false;
      doc.error = true;
    }
  );
  return doc;
}


async function actData() {

  let servi
  panelController.update((service) => {

    servi = service;
    return service;

  });

  let doc = { data: [], status: true, error: false, err: '' };

  try {

    const mesaRef = db.collection('service').doc(servi.firebase.docs[0].id);
    await mesaRef.update(servi.service);
    doc = { error: false, status: true };
   ;
    
  } catch (error) {
    
    doc.status = false;
    doc.error = true;
    doc.err = error;

  }

  return doc;
}

async function readDocs(collection) {

  let doc = { data: [], status: true, error: false, err: '' };
  try {
    const querySnapshot = await db.collection(collection).get();

    querySnapshot.forEach((docs) => {
      doc.data.push({ doc: { ...docs.data() }, id: docs.id });

    });
    doc.status = true;
    doc.error = false;
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
  }

  return doc;
}

const dropDoc = async (data) => {

  let doc = { data: [], status: true, error: false, err: '' };
  try {
    await db.collection(data.collection).doc(data.id).delete();
    doc = { status: true, error: false };
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
  }

  return doc;

};

const addDoc = async (data) => {

  let doc = { data: [], status: true, error: false, err: '' };
  try {
    doc.ref = await db.collection(data.collection).add(data.data);
    doc.data.id = doc.ref.id;
    doc.data.data = data.data;
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
  }

  return doc;

};



async function updateD(data) {
  let doc = { data: [], status: true, error: false, err: '' };
  try {
    const mesaRef = db.collection(data.collection).doc(data.id);
    await mesaRef.update(data.data);
    doc = { error: false, status: true };
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
  }
  return doc;

}

const searchDoc = async (data) => {

  let doc = { data: [], status: true, error: false, err: '', dataBlock: false };
  let docref = await db
    .collection(data.collection)
    .where(data.data[0], data.data[1], data.data[2])
    .get()
    .then((querySnapshot) => {

      querySnapshot.forEach((docs) => {
        console.log("docs.data()",docs.data());
        
        doc.data.push({ doc: docs.data(), id: docs.id });



      });
      doc.status = true;
      doc.error = false;
      doc.dataBlock = querySnapshot.empty;
    })
    .catch((error) => {
      doc.status = false;
      doc.error = true;
      doc.err = error;
      doc.dataBlock = querySnapshot.empty;

    });

  return doc;

};

export async function countDocs(collection) {

  let doc = { data: [], status: true, error: false, err: '' };

  try {
    await db.collection(collection).onSnapshot(querySnapshot => {
      querySnapshot.forEach(doc => {
        // Obtén los datos del documento y agrega el ID del documento al objeto
        doc.data = { id: doc.id, ...doc.data() };

      })

    });
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
  }

  return doc;

}

async function updateService(data) {
  let doc = { data: [], status: true, error: false, err: '' };
  let serv = {}
 /*  try {

    
    console.log('fn updateService',GetserviceData().data );
    console.log(GetserviceData().id,GetserviceData().collection);
    
    const mesaRef = db.collection(GetserviceData().collection).doc(GetserviceData().id);
    await mesaRef.update(GetserviceData().data);
    
    console.log('index',true);
    
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
    console.log(error);
    
  } */
  firebase.firestore()
  .collection(GetserviceData().collection)
  .doc(GetserviceData().id)
  .update(GetserviceData().data)
  .then(() => {
    doc.status = true;
    doc.error = false;
    
  })
  .catch((error) => {
     doc.error = true;
    doc.err = error;
  });

  return doc;
}



async function rdDocumentService(item) {
  let doc = { data: {}, status: true, error: false, err: '' };
  try {
     /* console.log('fn rdDocumentService'); */
    const docSnap = await getDoc(db.collection(GetserviceData().collection).doc(GetserviceData().id));
    if (docSnap.exists()) {
      doc.data = docSnap.data();
      updateDataService(docSnap.data());
      doc.status = true;
      doc.error = false;
    }
  } catch (error) {
    doc.status = false;
    doc.error = true;
    doc.err = error;
  }
  return doc;
}

export async function modelValid(data) {
  let doc;
  /* console.log(data); */

  switch (data.doc) {

    case "updateDoc":
      doc = await actData();
      break;
    case "update":
      doc = await updateD(data.data);
      break;
    case "Search":
      doc = await searchDoc(data.data);
      break;
    case "deleteDoc":
      doc = await dropDoc(data.data);
      break;
    case "createDoc":
      doc = await addDoc(data.data);
      break;
    case "updateService":
      doc = await updateService(data.data);
      break;

    case "rdDocumentService":
      doc = await rdDocumentService(data.data);
      break;
    case "readDocs":
      doc = await readDocs(data.data);
      break;
    case "readDocRealTime":
      doc = await readReadTime(data.data);
      break;
    case "readDocs":
      doc = await countDocs(data.data);
      break;
    default:
      alert("error, no se encontro la opcion");
      break;
  }
 /*  console.log(doc); */

  if (doc.error) {

    if (await ResolverConexion()) {


      modelValid(data);
    }
  }

  return doc;
}

export async function ResolverConexion() {
  /* console.log("conexion reintentar"); */
  let res;
  modalS.update((values) => {
    values.reset();
    values.info.title = "Aviso";
    values.info.body = `Error de red, intenta mas tarde`;
    values.controllers.btn[0].text = `Reintentar`;
    values.controllers.btn[1].text = `Cerrar`;
    values.controllers.btn[0].status = true;
    values.controllers.btn[1].status = true;
    values.status = true;
    return values;
  });

  return new Promise((resolve, reject) => {
    modalS.update((value) => {
      value.resolve = resolve;
      value.reject = reject;
      return value;
    });
  });
}


